import { API } from "../../../../helpers/API/amplifyApi";
import dayjsTZ from "../../../../utils/dayjs";
import { useEffect } from "react";
import { useState } from "react";
import { InfoBluecIcon, InfoOvertime } from "../../../../assets/icons";
import { useAuth } from "../../../../authentication/authHelpers";
import InfoOvertimeModal from "./InfoOvertimeModal";
import "./WorkBeforeShift.scss";
import WorkBeforeShiftModal from "./WorkBeforeShiftModal";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { useSelector } from "react-redux";
import { eventTracker } from "../../../../utils/eventTracker";

const WorkBeforeShift = () => {
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [visible, setVisible] = useState(false);
  // const [open, setOpen] = useState(false);
  const [overtime, setOvertime] = useState([]);
  const [infoVisible, setInfoVisible] = useState(false);
  const [overtimeUser, setOvertimeUser] = useState([]);

  // const [specificData, setSpecificData] = useState([]);
  const { employee } = useAuth();
  const workBeforeShiftData = [
    "Data e krijimit",
    "Kërkesë për",
    "Statusi",
    "Ora e fillimit",
    "Ora e mbarimit",
    "Lloji i kërkesës",
  ];
  const getColor = (reqStatus) => {
    switch (reqStatus) {
      case "Aprovuar":
        // autumn theme
        return "#1da193";
      case "Refuzuar":
        return "#CD1818";
      case "Në pritje":
        return "#1d3943";
      default:
        return "#9c5708";
    }
  };

  useEffect(() => {
    if (overtime?.records?.length > 0) {
      setOvertimeUser(
        overtime?.records?.filter((el) => el?.userSub === employee?.userSub)
      );
    }
  }, [overtime]);

  const getEmployeeOvertime = async () => {
    await API.get("employeeOvertime", "/employeeOvertime").then((e) =>
      setOvertime(e)
    );
  };

  useEffect(() => {
    getEmployeeOvertime();
  }, []);

  return (
    <>
      {overtimeUser?.length > 0 ? (
        <>
          <div className="workBeforeShiftData">
            {workBeforeShiftData?.map((el) => {
              return <div className="header-item-tip">{el}</div>;
            })}
          </div>
          <>
            <div className={`containerOvertime ${isDarkMode ? "dark" : ""}`}>
              {overtimeUser?.map?.((el, i) => (
                <div className="item-overtime">
                  <div
                    style={{
                      width: "16%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {dayjsTZ(el?.createdAt).format("DD/MM/YYYY")}
                  </div>
                  <div
                    style={{
                      width: "16%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {dayjsTZ(el?.overtimeDay).format("DD/MM/YYYY")}
                  </div>
                  <div
                    style={{
                      //   paddingRight: 20,
                      width: "16%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "100px",
                        height: 24,
                        backgroundColor: getColor(el?.requestStatus),
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#fff",
                        borderRadius: 5,
                      }}
                    >
                      {el.requestStatus}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "16%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {el?.requestPeriod[0]}
                  </div>
                  <div
                    style={{
                      width: "16%",
                      display: "flex",
                      justifyContent: "center",
                      paddingRight: 30,
                    }}
                  >
                    {el?.requestPeriod[1]}
                  </div>
                  <div
                    style={{
                      width: "16%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {el.requestType}
                  </div>
                </div>
              ))}
            </div>
          </>

          <div className="buttonFooterOvertime">
            <MondayButton
              className="mondayButtonGreen"
              Icon={<InfoOvertime />}
              onClick={() => setInfoVisible(true)}
            >
              Kur mund të krijosh leje?
            </MondayButton>
            <MondayButton
              className="mondayButtonGreen"
              onClick={() => {
                setVisible(true);
                eventTracker(
                  "Employee Overtime",
                  "click",
                  "Opened overtime modal"
                );
              }}
            >
              Krijo nje kërkesë për orë shtesë
            </MondayButton>{" "}
          </div>
        </>
      ) : (
        <div className={`noOvertimeUser ${isDarkMode ? "dark" : ""}`}>
          <InfoBluecIcon
            style={{
              height: 45,
              width: 45,
            }}
          />
          <div className="noOvertime">Nuk ke kërkesë për orë shtesë.</div>
          <div className="noOvertime-greet">
            Përshëndetje <strong>{employee?.employeeFirstName}</strong>,
            aktualisht ti nuk ke asnjë kërkesë për orë shtesë. Kliko butonin më
            poshtë për të krijuar një.
          </div>
          <div className="noOvertime-actionButtons">
            <MondayButton
              className="mondayButtonGreen"
              Icon={<InfoOvertime />}
              onClick={() => setInfoVisible(true)}
            >
              Kur mund të krijosh leje?
            </MondayButton>
            <MondayButton
              className="mondayButtonGreen"
              onClick={() => setVisible(true)}
            >
              Krijo nje kërkesë për orë shtesë
            </MondayButton>{" "}
          </div>
        </div>
      )}
      <>
        <WorkBeforeShiftModal
          {...{ visible, setVisible, overtime, setOvertimeUser }}
        />
        <InfoOvertimeModal {...{ infoVisible, setInfoVisible, setVisible }} />
      </>
    </>
  );
};

export default WorkBeforeShift;
